
export enum NoticeMarkup {
  PLAIN,
  HTML
}
